import * as TYPES from './constants';
import {
  requestSuperUserLicense,
  receiveSuperUserLicense,
  handleSuperUserLicenseError,
} from './actions';

import {Services} from 'core';

import {API} from 'config/superuser.config';

const initialState = {
  data: null,
  request: null,
  error: null,
};

const services = new Services();
export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_SUPER_USER_LICENSE:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_SUPER_USER_LICENSE:
      return {
        ...state,
        data: action.payload,
        request: false,
        error: false,
      };
    case TYPES.SUPER_USER_LICENSE_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchSuperUserLicense = () => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  dispatch(requestSuperUserLicense());
  let endpoint = `${API.administration.license}`;
  try {
    return services
      .fetchRecords(endpoint, token)
      .then(res => {
        dispatch(receiveSuperUserLicense(res));
      })
      .catch(err => console.log(err));
  } catch (err) {
    console.log(err);
    dispatch(handleSuperUserLicenseError(err));
  }
};
